<script setup lang="ts">
import './assets/style.scss'
import { useModel } from './../model/model.ts'
import { VModal } from '@/shared/ui'
import { computed, ref, watch } from 'vue'
import { ObjectSearch } from '@/widgets'
import { useSendForm } from './../model/api.ts'
import { ObjectTypeIds } from '@/entities/Object'

const model = useModel()
const { sendForm, isPending } = useSendForm()

const valid = ref(false)

/** Вычисляем заголовки */
const labels = computed(() => {
  const isRename = model.editType === 'rename'

  return {
    title: isRename ? 'itf.schedules_edit' : 'itf.schedules_move',
    button: isRename ? 'itf.edit' : 'itf.move',
  }
})

/**
 * Функция обработчик отправки формы
 */
const submitHandler = () => {
  sendForm(model.data, valid.value).then(model.closeForm)
}

/* Подгружаем данные формы */
const { refetch, isPending: isLoading } = model.loadData()

watch(
  () => model.editId,
  () => {
    if (model.editId) refetch()
  },
)
</script>

<template>
  <VModal v-model="model.openForm" :max-width="450" :title="$t(labels.title)">
    <VForm class="pt-2" v-model="valid" @submit.prevent="submitHandler" :disabled="isLoading">
      <template v-if="model.editType === 'move'">
        <ObjectSearch
          v-model="model.data.group_object_list_id"
          :label="$t('itf.select_root_object')"
          :object_type="ObjectTypeIds.GROUPS"
        />
      </template>

      <VTextField
        v-model="model.data.name"
        :label="$t('itf.name_label')"
        :rules="model.rules.name"
        :disabled="model.editType === 'move'"
      />

      <template v-if="model.editType !== 'move'">
        <VTextarea v-model="model.data.description" :label="$t('itf.description')" />
      </template>

      <div class="form__btn_right mt-4">
        <VBtn type="submit" :loading="isPending">{{ $t(labels.button) }}</VBtn>

        <VBtn color="default" @click="model.openForm = false">
          {{ $t('itf.close') }}
        </VBtn>
      </div>
    </VForm>
  </VModal>
</template>
